import React, { useState, useMemo, useEffect } from 'react';
import { get, round } from 'lodash';
import { Button, Typography } from '@telus-uds/components-web';
import { Formik, Form, Field } from 'formik';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';
import Edit from '@telus-uds/palette-allium/build/web/icons/Edit';
import PropTypes from 'prop-types';
import Modal from '../../../design/shared/modal';
import Select from 'react-select';

import {
  ModalFieldLabel,
  ModalFooter,
  Table,
  Tr,
  Td,
  Th,
  TdImp,
  TdLabel
} from './css';
import { formatCurrency } from '../../../utils/currencyFormatter';
import request from '../../../utils/request';
import { ocdrContractTermFiveYear, ocdrContractTermOneYear, ocdrContractTermThreeYear } from '../../../utils/constant';
import { Error } from '../../../design/elements';
import { listOfTerm } from './constant';
import { resetField, setDiscountFields } from './utils';

const OcdrAddProduct = ({
  onChange,
  defaultValues,
  orderData,
  productPriceofMC,
  bundleName,
  contractTerm,
  microsoftlicensingSelections,
  setMicrosoftlicensingSelections,
  errorMC
}) => {
  const [isModalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [categories, setCategories] = useState([]);
  const [licensesTerm, setLicensesTerm] = useState([]);
  const [licensesTermData, setLicensesTermData] = useState([]);
  const [optionsOfEditions, setOptionsOfEditions] = useState([]);
  const [disableFieldOneTime, setDisableFieldOneTime] = useState(true);
  const [
    disableFieldMonthlyRecurring,
    setDisableFieldMonthlyRecurring
  ] = useState(true);

  const [errors, setErrors] = useState();

  useEffect(() => {
    if (!microsoftlicensingSelections.length) {
      setMicrosoftlicensingSelections(get(defaultValues, 'selections', []));
    }
  }, [orderData]);

  useEffect(() => {
    const fetchData = async () => {
      let categoriesName = [];
      const dataCategories = await request.get(`/products/categories`);
      dataCategories.data.slice(6, 13).forEach(categoryData => {
        categoriesName.push(categoryData.name);
      });
      setCategories(categoriesName);
    };
    fetchData();
  }, []);

  //  const term = ['OneTime:OnTime','P1M:Monthly','P1Y:Annual','P1Y:Monthly','P1Y:OneTime','P3Y:Annual','P3Y:Monthly','P3Y:Triennial']

  const optionTermToproductTermKey = {
    [ocdrContractTermOneYear]: 'oneYear',
    [ocdrContractTermThreeYear]: 'threeYears',
    [ocdrContractTermFiveYear]: 'fiveYears'
  }
  
  const totals = useMemo(() => {
    let totalmonthlyCharges = 0;
    let totaloneTimeCharge = 0;
    let totalmonthlyChargesDiscount = 0;
    let totaloneTimeChargeDiscount = 0;
    microsoftlicensingSelections.forEach(item => {
      totalmonthlyCharges += round(item.monthlyChargesTotal, 2);
      totaloneTimeCharge += round(item.oneTimeChargeTotal, 2);
      totalmonthlyChargesDiscount += round(item.monthlyDiscountTotal, 2);
      totaloneTimeChargeDiscount += round(item.onetimeDiscountTotal, 2);
    });
    return {
      totalMonthlyPrice: totalmonthlyCharges,
      totalOneTimePrice: totaloneTimeCharge,
      totalMonthlyPriceDiscount: totalmonthlyChargesDiscount,
      totalOneTimePriceDiscount: totaloneTimeChargeDiscount
    };
  }, [microsoftlicensingSelections]);

  const adjustedTotalPrice = useMemo(() => {
    const totalMonthlyPrice = totals.totalMonthlyPrice;
    const totalOneTimePrice = totals.totalOneTimePrice;

    return {
      totalMonthlyPrice,
      totalOneTimePrice
    };
  }, [totals]);

  const adjustedTotalPriceDiscount = useMemo(() => {
    const totalMonthlyPriceDiscount = totals.totalMonthlyPriceDiscount;
    const totalOneTimePriceDiscount = totals.totalOneTimePriceDiscount;

    return {
      totalMonthlyPriceDiscount,
      totalOneTimePriceDiscount
    };
  }, [totals]);

  const showModal = (e) => {
    setModalData(null);
    setDisableFieldOneTime(true);
    setDisableFieldMonthlyRecurring(true);
    setModalVisible(true);
    setOptionsOfEditions([]);
  };

  const onCloseModal = () => {
    setModalVisible(false);
  };

  const addLicencingRow = row => {
    if (row.quantity <= 0) {
      setErrors(prevErrors => ({
        ...prevErrors,
        quantity: 'Quantity of Licenses must be greater than 0'
      }));
      return;
    }
    setMicrosoftlicensingSelections([...microsoftlicensingSelections, row]);
  };

  const editItem = (e, row) => {
    e.preventDefault();
    setModalData(row);
    setModalVisible(true);
  };

  const handleWheel = e => e.target.blur();

  const deleteItem = (e, idx) => {
    e.preventDefault();
    setMicrosoftlicensingSelections([
      ...microsoftlicensingSelections.slice(0, idx),
      ...microsoftlicensingSelections.slice(idx + 1)
    ]);
  };

  useEffect(() => {
    onChange({
      selections: microsoftlicensingSelections,
      adjustedTotalPrice,
      adjustedTotalPriceDiscount
    });
  }, [
    microsoftlicensingSelections,
    adjustedTotalPrice,
    adjustedTotalPriceDiscount
  ]);

  return (
    <div>
      {!!microsoftlicensingSelections.length && (
        <Table>
          <Th><Typography>Product</Typography></Th>
          <Th><Typography>Monthly Charges</Typography></Th>
          <Th><Typography>Monthly Discount(%)</Typography></Th>
          <Th><Typography>OneTime Charge</Typography></Th>
          <Th><Typography>Onetime Discount(%)</Typography></Th>
          <Th><Typography>Quantity</Typography></Th>
          <Th colSpan={2}><Typography>Actions</Typography></Th>{' '}
          {/* Add this column for edit/delete buttons */}
          {microsoftlicensingSelections.map(
            (
              {
                sku,
                editions,
                quantity,
                monthlyCharges,
                monthlyDiscount,
                oneTimeCharge,
                onetimeDiscount
              },
              idx
            ) => (
              // eslint-disable-next-line react/no-array-index-key
              <Tr key={`${oneTimeCharge}-${monthlyCharges}-${idx}`}>
                <Td><Typography>{`${editions},${sku}`}</Typography></Td>
                <Td><Typography>${monthlyCharges}</Typography></Td>
                <Td><Typography>{monthlyDiscount}%</Typography></Td>
                <Td><Typography>${oneTimeCharge}</Typography></Td>
                <Td><Typography>{onetimeDiscount}%</Typography></Td>
                <Td><Typography>{quantity}</Typography></Td>
                {/* <Td>{formatCurrency(totalCost)}</Td>
                <Td>{formatCurrency(totalPrice)}</Td> */}
                <Td>
                  <Button
                    icon={Edit}
                    onPress={e =>
                      editItem(e, microsoftlicensingSelections[idx])
                    }
                    variant={{ text: true }}
                    accessibilityLabel="Edit"
                  />
                </Td>
                <Td>
                  <Button
                    icon={Delete}
                    onPress={e => deleteItem(e, idx)}
                    variant={{ text: true }}
                    accessibilityLabel="Delete"
                  />
                </Td>
              </Tr>
            )
          )}
          <Tr>
            <TdLabel colSpan={1}>Total</TdLabel>
            <TdImp><Typography>{formatCurrency(totals.totalMonthlyPrice)}</Typography></TdImp>
            <Td></Td>
            <TdImp><Typography>{formatCurrency(totals.totalOneTimePrice)}</Typography></TdImp>
          </Tr>
          <Tr>
            <TdLabel colSpan={1}>Total with Discount</TdLabel>
            <TdImp><Typography>{formatCurrency(totals.totalMonthlyPriceDiscount)}</Typography></TdImp>
            <Td></Td>
            <TdImp><Typography>{formatCurrency(totals.totalOneTimePriceDiscount)}</Typography></TdImp>
          </Tr>
        </Table>
      )}
      <Button variant={{ priority: 'high' }} type="button"
        onClick={showModal}
        
        disabled={bundleName && contractTerm ? false : true}
        name= "addProductMC">
        Add Product
      </Button>
      {errorMC && <Error text={'Field is required'} />}
      <Modal
        open={isModalVisible}
        setOpen={onCloseModal}
        size="large"
        header={modalData ? 'Edit Product' : 'Add Product'}
      >
        <Formik
          initialValues={
            modalData || {
              category: '',
              editions: '',
              sku: '',
              licenseTerm: 0,
              quantity: 0,
              monthlyCharges: 0,
              monthlyDiscount: 0,
              oneTimeCharge: 0,
              onetimeDiscount: 0,
              monthlyChargesTotal: 0,
              monthlyDiscountTotal: 0,
              oneTimeChargeTotal: 0,
              onetimeDiscountTotal: 0,
              currentPriceMonthly: 0,
              currentPriceOneTime: 0,
              bundleName:'',
              contractTerm:''
            }
          }
          onSubmit={values => {
            values['monthlyChargesTotal'] =
              values['currentPriceMonthly'] * values['quantity'];
            values['oneTimeChargeTotal'] =
              values['currentPriceOneTime'] * values['quantity'];
            values['monthlyDiscountTotal'] =
              values['monthlyCharges'] * values['quantity'];
            values['onetimeDiscountTotal'] =
              values['oneTimeCharge'] * values['quantity'];
            if (modalData) {
              // Update existing row
              const updatedSelections = [...microsoftlicensingSelections];
              updatedSelections[
                microsoftlicensingSelections.indexOf(modalData)
              ] = values;
              setMicrosoftlicensingSelections(updatedSelections);
            } else {
              // Add new row
              addLicencingRow(values);
            }
            if (values.quantity !== 0 && (!errors || !errors.quantity)) {
              onCloseModal();
            }
          }}
        >
          {({ values, setFieldValue, resetForm, submitForm }) => (
            <Form>
              <div>
                <ModalFieldLabel>Category:</ModalFieldLabel>
                <Field
                  as="select"
                  id="category"
                  name="category"
                  className="frg-input-field color-light"
                  onChange={e => {
                    resetForm();
                    const selectedCategory = e.target.value;
                    setFieldValue('category', selectedCategory);
                    setFieldValue('bundleName',bundleName);
                    if (productPriceofMC[selectedCategory]) {
                      const optionData = [];
                      productPriceofMC[selectedCategory].forEach(data => {
                        optionData.push({
                          value: data.name,
                          label: data.name
                        });
                      });
                      setOptionsOfEditions(optionData);
                    }
                  }}
                  required
                >
                  <option value="">Select Category</option>
                  {categories.map(category => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </Field>
              </div>
              <div>
                <ModalFieldLabel htmlFor="Editions">Editions:</ModalFieldLabel>
                <Select
                  value={
                    optionsOfEditions.find(
                      option => option.value === values.editions
                    ) || null
                  }
                  onChange={option => {
                    const selectedCategory = option.value;
                    let addLicensesTermData = [];
                    setFieldValue('editions', selectedCategory);

                      const matchedProduct =
                        productPriceofMC[values.category] &&
                        productPriceofMC[values.category].find(
                          skuProduct => skuProduct.name === selectedCategory
                        );

                    setFieldValue('sku', matchedProduct.sku || '');

                    matchedProduct.prices &&
                      Object.entries(matchedProduct.prices).map(key => {
                        listOfTerm[key[0]] &&
                          addLicensesTermData.push(listOfTerm[key[0]](key[1]));
                      });

                    setLicensesTerm(
                      addLicensesTermData.map(data => data.value)
                    );
                    setLicensesTermData(addLicensesTermData);
                  }}
                  options={optionsOfEditions}
                  isSearchable={true}
                  menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                  styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                  required
                />
              </div>
              <div>
                <ModalFieldLabel>Term & Payment:</ModalFieldLabel>
                <Field
                  as="select"
                  id="licenseTerm"
                  name="licenseTerm"
                  className="frg-input-field color-light"
                  value={values.licenseTerm}
                  onChange={e => {
                    const selectedTerm = e.target.value;
                    setFieldValue('licenseTerm', selectedTerm); // Reset Subscription Line Option

                    //reset the below fields
                    resetField(setFieldValue);

                      const matchedProduct = productPriceofMC[values.category].find(
                        skuProduct => skuProduct.name === values.editions
                      );

                      const applyDiscount = (data, priceField, price) => {
                        const discountKey = optionTermToproductTermKey[contractTerm];
                        const discount = data[discountKey];
                        if (discount) {
                          setFieldValue(priceField, (price - price * (discount / 100)).toFixed(2));
                        }
                      };

                      const processBundle = (priceField, discountField, termData) => {
                        if (matchedProduct && matchedProduct.productBundles.length > 0) {
                          matchedProduct.productBundles.forEach(data => {
                            if (data.productBundle.name === bundleName) {
                              setDiscountFields(data, discountField, setFieldValue, contractTerm);
                              applyDiscount(data, priceField, termData.prices);
                            }
                          });
                        }
                      };

                    licensesTermData.forEach(termData => {
                      if (termData.value === selectedTerm) {
                        if (termData.payment === 'oneTime') {
                          setFieldValue('oneTimeCharge', termData.prices);
                          setFieldValue('currentPriceOneTime', termData.prices);
                          setDisableFieldOneTime(false);
                          processBundle('oneTimeCharge', 'onetimeDiscount', termData);
                        } else {
                          setDisableFieldOneTime(true);
                        }
                        if (termData.payment === 'monthly') {
                          setFieldValue('monthlyCharges', termData.prices);
                          setFieldValue('currentPriceMonthly', termData.prices);
                          setDisableFieldMonthlyRecurring(false);
                          processBundle('monthlyCharges', 'monthlyDiscount', termData);
                        } else {
                          setDisableFieldMonthlyRecurring(true);
                        }
                      }
                    });
                  }}
                  required
                >
                  <option value="">Select License Term</option>
                  {licensesTerm.map(license => (
                    <option key={license} value={license}>
                      {license}
                    </option>
                  ))}
                </Field>
              </div>
              <div>
                <ModalFieldLabel htmlFor="cost">Quantity:</ModalFieldLabel>
                <Field
                  type="number"
                  id="quantity"
                  name="quantity"
                  className="frg-input-field color-light"
                  value={values.quantity}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  onChange={e => {
                    const { value } = e.target;
                    setFieldValue('quantity', value);
                    setErrors(prevErrors => ({
                      ...prevErrors,
                      quantity:
                        value > 0
                          ? ''
                          : 'Quantity of Licenses must be greater than 0'
                    }));
                  }}
                  required
                />
                {errors && errors.quantity && (
                  <div style={{ color: 'red' }}><Typography>{errors.quantity}</Typography></div>
                )}
              </div>
              <div>
                <ModalFieldLabel htmlFor="cost">
                  Recurring Charge:
                </ModalFieldLabel>
                <Field
                  type="number"
                  id="monthlyCharges"
                  name="monthlyCharges"
                  className="frg-input-field color-light"
                  value={values.monthlyCharges}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  disabled
                />
              </div>
              <div>
                <ModalFieldLabel htmlFor="cost">
                  Recurring Discount (%):
                </ModalFieldLabel>
                <Field
                  disabled={disableFieldMonthlyRecurring}
                  type="number"
                  id="monthlyDiscount"
                  name="monthlyDiscount"
                  className="frg-input-field color-light"
                  value={values.monthlyDiscount}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  onChange={e => {
                    const selectedTerm = e.target.value;
                    setFieldValue('monthlyDiscount', selectedTerm);
                    licensesTermData.forEach(data => {
                      if (data.value === values.licenseTerm) {
                        setFieldValue(
                          'monthlyCharges',
                          (
                            data.prices -
                            data.prices * (selectedTerm / 100)
                          ).toFixed(2)
                        );
                      }
                    });
                  }}
                />
              </div>
              <div>
                <ModalFieldLabel htmlFor="cost">
                  One Time Charge:
                </ModalFieldLabel>
                <Field
                  type="number"
                  id="oneTimeCharge"
                  name="oneTimeCharge"
                  className="frg-input-field color-light"
                  value={values.oneTimeCharge}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  disabled
                />
              </div>
              <div>
                <ModalFieldLabel htmlFor="cost">
                  One time Discount (%):
                </ModalFieldLabel>
                <Field
                  disabled={disableFieldOneTime}
                  type="number"
                  id="onetimeDiscount"
                  name="onetimeDiscount"
                  className="frg-input-field color-light"
                  value={values.onetimeDiscount}
                  onWheel={handleWheel}
                  style={{ width: '100%' }}
                  onChange={e => {
                    const selectedOneTime = e.target.value;
                    setFieldValue('onetimeDiscount', selectedOneTime);
                    licensesTermData.forEach(data => {
                      if (data.value === values.licenseTerm) {
                        setFieldValue(
                          'oneTimeCharge',
                          (
                            data.prices -
                            data.prices * (selectedOneTime / 100)
                          ).toFixed(2)
                        );
                      }
                    });
                  }}
                />
              </div>
              <ModalFooter>
                <Button onClick={submitForm}>Add</Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

OcdrAddProduct.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValues: PropTypes.shape({}).isRequired,
  orderData: PropTypes.shape({}).isRequired
};

export default OcdrAddProduct;
